import BigNumber from "bignumber.js";
import {isEmpty} from "./StringUtils";

export function numStrFormat(str){
    if(isEmpty(str)||isNaN(str.replace(/,/g, ''))){
        return str
    }else{
        str=str.replace(/,/g,'');
        return new BigNumber(str).dp(2,BigNumber.ROUND_DOWN).toFormat();
    }
}
export function numStrFormatTwoDecimal(str){
    if(isEmpty(str)||isNaN(str.replace(/,/g, ''))){
        return str
    }else{
        str=str.replace(/,/g,'');
        let displayDecimalSetting = sessionStorage.getItem("displayDecimalSetting");
        let places = 2;
        if(!isEmpty(displayDecimalSetting)){
            places = parseInt(displayDecimalSetting);
        }
        return new BigNumber(str).dp(places,BigNumber.ROUND_DOWN).toFormat(places);
    }
}
export function numStrFormat2(str,len){
    if(isEmpty(str)||isNaN(str.replace(/,/g, ''))){
        return str;
    }else{
        str=str.replace(/,/g,'');
        return new BigNumber(str).dp(len,BigNumber.ROUND_DOWN).toFormat();
    }
}
export function numStrFormat3(str,len){
    if(isEmpty(str)||isNaN(str.replace(/,|-/g, ''))){
        return str;
    }else{
        str=str.replace(/,|-/g,'');
        if(len){
            return new BigNumber(str).dp(len,BigNumber.ROUND_DOWN).toFormat();
        }else{
            return new BigNumber(str).toFormat();
        }
    }
}
export function numberFormat(numStr,floatLength){
    if(isEmpty(floatLength)){
        floatLength=8;
    }
    let numArr = numStr.replace(/,/g,'').split(".");
    let intNumStr = numArr[0];
    let floatNumStr='';
    let numFormat=0;
    if(numArr.length>1){
        floatNumStr = numArr[1];
    }
    if(intNumStr.length>12){
        intNumStr=intNumStr.substr(0,12);
    }
    if(floatNumStr.length>floatLength){
        floatNumStr=floatNumStr.substr(0,floatLength);
    }
    if(!isEmpty(floatNumStr)){
        numFormat=floatNumStr.length;
    }
    numStr=intNumStr;
    if(!isEmpty(floatNumStr)){
        numStr=numStr+'.'+floatNumStr;
    }
    let x = new BigNumber(numStr).dp(numFormat,BigNumber.ROUND_DOWN).toFormat(numFormat);
    return x;
}
export function str2Num(str,floatLength){
    return new BigNumber(str.replace(/,|-/g,''));
}

export function str2NegativeNum(str,floatLength){
    return new BigNumber('-'+(str.replace(/,|-/g,'')));
}
export function numFormat(num){
    return new BigNumber(num+"").toFormat();
}
export function numFormatTwoDecimal(num){
    return new BigNumber(num+"").toFormat(2);
}

/**
 * 计算两个数的乘积
 * @param num1
 * @param num2
 * @returns {string}
 */
export function calculation(num1,num2){
    const qty = new BigNumber(num1);
    const price = new BigNumber(num2);
    const totalAmount = qty.times(price);
    return new BigNumber(totalAmount+"").toFormat()
}

/**
 * 计算两个数的加和
 * @param num1
 * @param num2
 * @returns {string}
 */
export function numPlus(num1,num2){
    if(isEmpty(num1)){
        num1 = "0";
    }
    if(isEmpty(num2)){
        num2 = "0";
    }
    if(num1 == "-"){
        num1 = "-0";
    }
    if(num2 == "-"){
        num2 = "-0";
    }
    const numStr1 = num1+"";
    const numStr2 = num2+"";
    const numTmp1 = new BigNumber(numStr1.replace(/,/g,''));
    const numTmp2 = new BigNumber(numStr2.replace(/,/g,''));
    return numTmp1.plus(numTmp2).toFormat()
}
/**
 * 计算两个数的相减
 * @param num1
 * @param num2
 * @returns {string}
 */
export function numMinus(num1,num2){
    if(isEmpty(num1)){
        num1 = "0";
    }
    if(isEmpty(num2)){
        num2 = "0";
    }
    if(num1 == "-"){
        num1 = "-0";
    }
    if(num2 == "-"){
        num2 = "-0";
    }
    const numStr1 = num1+"";
    const numStr2 = num2+"";
    const numTmp1 = new BigNumber(numStr1.replace(/,/g,''));
    const numTmp2 = new BigNumber(numStr2.replace(/,/g,''));
    return numTmp1.minus(numTmp2).toFormat()
}
/**
 * 计算两个数的相乘
 * @param num1
 * @param num2
 * @returns {string}
 */
export function numTimes(num1,num2){
    let numStr1 = num1+"";
    let numStr2 = num2+"";
    if(numStr1 == "-"){
        numStr1 = "-0";
    }
    if(numStr2 == "-"){
        numStr2 = "-0";
    }
    const numTmp1 = new BigNumber(numStr1.replace(/,/g,''));
    const numTmp2 = new BigNumber(numStr2.replace(/,/g,''));
    return numTmp1.times(numTmp2).dp(8, BigNumber.ROUND_DOWN).toFormat();
}

export function numTimesView(num1,num2){
    let numStr1 = num1+"";
    let numStr2 = num2+"";
    if(numStr1 == "-"){
        numStr1 = "-0";
    }
    if(numStr2 == "-"){
        numStr2 = "-0";
    }
    const numTmp1 = new BigNumber(numStr1.replace(/,/g,''));
    const numTmp2 = new BigNumber(numStr2.replace(/,/g,''));
    let displayDecimalSetting = sessionStorage.getItem("displayDecimalSetting");
    let places = 2;
    if(!isEmpty(displayDecimalSetting)){
        places = parseInt(displayDecimalSetting);
    }
    return numTmp1.times(numTmp2).dp(8, BigNumber.ROUND_DOWN).toFormat(places);
}
/**
 * 计算两个数的相除
 * @param num1
 * @param num2
 * @returns {string}
 */
export function numDiv(num1,num2){
    const numStr1 = num1+"";
    const numStr2 = num2+"";
    const numTmp1 = new BigNumber(numStr1.replace(/,/g,''));
    const numTmp2 = new BigNumber(numStr2.replace(/,/g,''));
    return numTmp1.div(numTmp2).dp(8, BigNumber.ROUND_DOWN).toFormat()
}
/**
 * 两个数做比较
 * @param num1
 * @param num2
 * @returns {number} num1>num2 => 1 ; num1=num2 => 0 ; num1<num2 => -1
 */
export function numCompare(num1,num2){
    const numStr1 = num1+"";
    const numStr2 = num2+"";
    const numTmp1 = new BigNumber(numStr1.replace(/,/g,''));
    const numTmp2 = new BigNumber(numStr2.replace(/,/g,''));
    return numTmp1.comparedTo(numTmp2);
}

/**
 * 两个数绝对值做比较
 * @param num1
 * @param num2
 * @returns {number} num1>num2 => 1 ; num1=num2 => 0 ; num1<num2 => -1
 */
export function numAbsCompare(num1,num2){
    const numStr1 = num1+"";
    const numStr2 = num2+"";
    const numTmp1 = new BigNumber(numStr1.replace(/,/g,'')).abs();
    const numTmp2 = new BigNumber(numStr2.replace(/,/g,'')).abs();
    return numTmp1.comparedTo(numTmp2);
}
